// extracted by mini-css-extract-plugin
module.exports = {"primary":"_id__primary__HSQQY primaryButton biggerButton","secondary":"_id__secondary__D9XXk secondaryButton biggerButton"};